"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.Data = exports.TodoElem = void 0;
var TodoElem = /** @class */ (function () {
    function TodoElem(text, date) {
        if (date === void 0) { date = Date.now(); }
        var d = new Date(date);
        var d_fmt = String(d.toLocaleDateString()) + "\n"
            + String(d.getHours()) + "h "
            + String(d.getMinutes()) + "min "
            + String(d.getSeconds()) + "sec";
        return {
            date: date,
            checked: false,
            text: text,
            dateString: d_fmt
        };
    }
    return TodoElem;
}());
exports.TodoElem = TodoElem;
var Data = /** @class */ (function () {
    function Data() {
        return {
            lists: {},
            addList: this.addList,
            removeList: this.removeList,
            addElemToList: this.addElemToList,
            removeElemFromList: this.removeElemFromList,
            modifyTextFromListElem: this.modifyTextFromListElem,
            toggleItemFromList: this.toggleItemFromList,
            listEntries: this.listEntries,
            renameList: this.renameList,
            editItemText: this.editItemText,
            moveElemFromToList: this.moveElemFromToList,
            __ToJSON: this.__ToJSON,
            __FromJSON: this.__FromJSON
        };
    }
    Data.prototype.__ToJSON = function () {
        // return "love"
        return JSON.stringify(Object.entries(this.lists).map(function (_a) {
            var name = _a[0], todo = _a[1];
            return [name, todo.map(function (x) { return JSON.stringify(x); })];
        }));
    };
    Data.prototype.__FromJSON = function (data) {
        var instance = new Data();
        var data0 = JSON.parse(data);
        var data1 = data0.map(function (_a) {
            var k = _a[0], v = _a[1];
            return [k, v.map(function (x) { return JSON.parse(x); })];
        });
        data1.forEach(function (_a) {
            var x = _a[0], y = _a[1];
            return instance.lists[x] = y;
        });
        return instance;
    };
    Data.prototype.addList = function (name) {
        var copy = __assign({}, this);
        if (name !== undefined) {
            copy.lists[name] = [];
            return;
        }
        var number = 0;
        var lname = "TodoList " + String(number);
        while (Object.keys(copy.lists).includes(lname)) {
            number += 1;
            lname = "TodoList " + String(number);
        }
        copy.lists[lname] = [];
        return copy;
    };
    Data.prototype.removeList = function (listName) {
        var copy = __assign({}, this);
        delete copy.lists[listName];
        return copy;
    };
    Data.prototype.addElemToList = function (listName, elem) {
        var copy = __assign({}, this);
        var newelem = elem !== null && elem !== void 0 ? elem : new TodoElem("Task");
        if (!copy.lists[listName].find(function (x) { return x.date === newelem.date; })) {
            copy.lists[listName].push(newelem);
        }
        return copy;
    };
    Data.prototype.removeElemFromList = function (listName, elemDate) {
        var copy = __assign({}, this);
        copy.lists[listName] = copy.lists[listName].filter(function (x) { return x.date !== elemDate; });
        return copy;
    };
    Data.prototype.modifyTextFromListElem = function (listName, elemDate, newText) {
        var copy = __assign({}, this);
        copy.lists[listName] = copy.lists[listName].map(function (x) {
            if (x.date === elemDate) {
                x.text = newText;
                return x;
            }
            else {
                return x;
            }
        });
        return copy;
    };
    Data.prototype.toggleItemFromList = function (listName, elemDate) {
        var copy = __assign({}, this);
        var found = false;
        copy.lists[listName] = copy.lists[listName].map(function (x) {
            if (x.date === elemDate) {
                found = true;
                x.checked = !x.checked;
                return x;
            }
            else {
                return x;
            }
        });
        if (!found) {
            console.warn("invalid elemData in toggleItemFromList");
        }
        return copy;
    };
    Data.prototype.editItemText = function (listName, elemDate, newText) {
        var copy = __assign({}, this);
        copy.lists.listName = copy.lists.listName.map(function (x) {
            if (x.date !== elemDate) {
                return x;
            }
            else {
                var y = __assign({}, x);
                y.text = newText;
                return y;
            }
        });
        return copy;
    };
    Data.prototype.renameList = function (listName, newName) {
        if (listName === newName)
            return this;
        var copy = __assign({}, this);
        copy.lists[newName] = copy.lists[listName];
        delete copy.lists[listName];
        return copy;
    };
    Data.prototype.moveElemFromToList = function (listTo, elemDate) {
        var copy = __assign({}, this);
        var _a = copy.listEntries().find(function (_a) {
            var _ = _a[0], todos = _a[1];
            return todos.find(function (x) { return x.date === elemDate; }) !== undefined;
        }), listFrom = _a[0], _ = _a[1];
        var idx = copy.lists[listFrom].findIndex(function (elem) { return elem.date == elemDate; });
        var elem = copy.lists[listFrom][idx];
        copy.lists[listFrom].splice(idx, 1);
        copy.lists[listTo].push(elem);
        return copy;
    };
    Data.prototype.listEntries = function () {
        var list = Object.entries(this.lists);
        list.sort(function (_a, _b) {
            var a = _a[0], _ = _a[1];
            var b = _b[0], __ = _b[1];
            return a.localeCompare(b);
        });
        return list;
    };
    return Data;
}());
exports.Data = Data;
